"use client";

import { http } from "../httpHandler";
import { links } from "@/constants";
import { TServerErrorResponse } from "@/types";

export interface IsConnectedResponse {
  isConnected: boolean;
}

export const checkEmoneyConnection = async (): Promise<IsConnectedResponse> => {
  try {
    const response = await http.get<IsConnectedResponse>(
      links.emoney.isConnected,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
